(function ($) {
    
    $( window ).on( "load", function() {
        var element = $('#ast-mobile-header');
        var bottomPosition = element.offset().top + element.outerHeight();
        if (!$(document.body).hasClass('ast-primary-sticky-header-active')) {
            $('.ast-mobile-header-content').css('top', bottomPosition -1 );
        }
    } );

    var mobileArrow =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_2798_49326)"><path d="M23.9533 12.2485L12.3286 23.5313L0.668945 12.2146L3.35694 9.63953L10.4435 16.5176L10.4435 0.592941L14.2137 0.592941L14.2137 16.5176L21.3002 9.67341L23.9533 12.2485Z" fill="black"/></g><defs><clipPath id="clip0_2798_49326"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>';
    $('.ast-mobile-header-content .ast-menu-toggle .icon-arrow').each(function () {
        $(this).html(mobileArrow);
    });

    var firsSection = $('.content-area  section:first-child');
    if (
        firsSection.length > 0 &&
        firsSection.hasClass('mo-bg-white') &&
        firsSection.find('.mo-hero').length <= 0 &&
        firsSection.find('.mo-case-stories-hero').length <= 0 &&
        firsSection.find('.services-hero').length <= 0 &&
        firsSection.find('.offices-hero').length <= 0
    ) {
        $('.main-header-menu').addClass('text-color-black');
        $('.mobile-menu-toggle-icon').addClass('color-black');
    }
})(jQuery);
